import { CustomMessageBoardCollection } from '@/modules/common/message-board/components/shared/MessageBoard.vue'
import UserPhoneVerifyButton from '@/modules/user/components/shared/phone-verification/UserPhoneVerifyButton.vue'
import { MessageBoardCollection } from '@/modules/common/message-board/models/message-board-collection.model'
import UserProfileMailButton from '@/modules/user/components/shared/profile/UserProfileMailButton.vue'

export function MessageBoardCustomMessages(): CustomMessageBoardCollection[] {
  return [
    //Example--------------
    // {
    //   text: '<p>کاربران گرامی با توجه به تعطیلات نوروزی رسانه های با علامت<span>&nbsp;</span><img alt="" src="https://s2.uupload.ir/files/grass_nowruz_pmlg.png" style="height:15px; width:15px;margin-bottom: -2px" /><span></span>&nbsp;امکان درج در ایام نوروز را دارند</p>',
    //   key: 'active_on_nowruz',
    //   close: true,
    //   color: 'tes-green-holiday',
    //   user_type: UserType.PANEL,
    //   //extra
    //   icon: 'rose-outline'
    // }
    // {
    //   // text: 'جشنواره عید نوروز تسمینو از تاریخ ۱۴۰۱/۱۲/۶ تا ۱۴۰۱/۱۲/۱۴',
    //   text: '<p><strong>تا ۵۰٪ تخفیف از بهترین های وب</strong> با تایم<img alt="" src="https://em-content.zobj.net/source/microsoft-teams/337/victory-hand_270c-fe0f.png" style="height:20px; margin-bottom:-5px; margin-right:-5px margin-top:5px; width:20px" />وین . برای دریافت کد تخفیف دکمه روبرو را کلیک کنید</p>',
    //   url: 'https://time2win.ir/?utm_source=niknevis&utm_medium=Topbar&utm_campaign=redwed',
    //   button_text: 'دریافت کد تخفیف',
    //   key: 'active_on_nowruz',
    //   close: true,
    //   color: 'tes-gradient-coal-black',
    //   user_type: UserType.PANEL,
    //   //extra
    //   icon: 'flame-outline',
    //   noOutline: true
    // }
    // {
    //   // text: 'جشنواره عید نوروز تسمینو از تاریخ ۱۴۰۱/۱۲/۶ تا ۱۴۰۱/۱۲/۱۴',
    //   text: '<span style="color:#ffffff">جشنواره عید نوروز تسمینو از تاریخ </span><span style="background-color:#ffffff;color:#111111">&nbsp۱۴۰۱/۱۲/۶&nbsp</span><span style="color:#ffffff"> تا </span><span style="background-color:#ffffff;color:#111111">&nbsp۱۴۰۱/۱۲/۱۴&nbsp</span><span style="color:#ffffff"> .  برای ورود به جشنواره دکمه روبرو را کلیک کنید ... </span>',
    //   url: 'https://niknevis.com/nowruz/?utm_source=panel&utm_medium=bnr&utm_campaign=sale&utm_content=action',
    //   button_text: 'ورود به جشنواره',
    //   key: 'nowruz_festival',
    //   close: true,
    //   color: 'tes-gradient-orange',
    //   user_type: UserType.PANEL,
    //   //extra
    //   icon: 'megaphone-outline',
    //   noOutline: true
    // }
    // {
    //   text: 'لورم',
    //   type: 'warning',
    //   url: 'https://www.google.com',
    //   button_text: 'لورم دکمه',
    //   key: '5',
    //   close: true,
    //   user_type: UserType.ADMIN
    // },
    // {
    //   text: 'ایپسوم',
    //   type: 'info',
    //   url: 'https://www.google.com',
    //   button_text: 'ایپسوم دکمه',
    //   key: '3',
    //   close: false
    // }
  ]
}

export function MessageBoardAppendMessages(initialProps): MessageBoardCollection[] {
  let messages = [
    {
      text: 'کاربر گرامی تلفن همراه شما تایید نشده است،لطفا برای دریافت اعلانات از طریق پیامک لطفا نسبت به تایید آن اقدام فرمایید',
      button_text: 'تایید تلفن همراه',
      url: null,
      type: 'warning',
      component: UserPhoneVerifyButton,
      binds: {
        phone: initialProps.phone,
        isVerified: initialProps.initialProps?.verification_status.sms_notice || false,
        outline: true,
        color: 'tes-white',
        'button-class': 'q-px-lg'
      },
      event: 'showDialog'
    },
    {
      text: 'کاربر گرامی ، ایمیل شما تایید نشده است، برای دریافت اعلانات لطفا نسبت به تایید آن اقدام فرمایید',
      button_text: 'تایید ایمیل',
      url: null,
      type: 'warning',
      component: UserProfileMailButton,
      binds: {
        phone: initialProps.email,
        outline: true,
        color: 'tes-white',
        'button-class': 'q-px-lg'
      },
      event: 'showDialog'
    }
  ]

  //Exceptions------
  if (initialProps.initialProps?.verification_status.sms_notice) messages = messages.filter((item) => !item.button_text.includes('تلفن'))
  if (initialProps.initialProps?.verification_status.email_notice) messages = messages.filter((item) => !item.button_text.includes('ایمیل'))

  return messages
}